import { inject, Injectable } from '@angular/core'
import { NavController } from '@ionic/angular'

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private navCtrl = inject(NavController)

  async goToAssistantProfile(assistantId: number) {
    await this.navCtrl.navigateForward(`/menu/app/tabs/workers/assistant/${assistantId}/basic-info`)
  }

  async goToClientProfile(clientId: number) {
    await this.navCtrl.navigateForward(`/menu/app/tabs/clients/client/${clientId}/basic-info`)
  }

  async goToLogin() {
    await this.navCtrl.navigateRoot('/login')
  }
}
